export enum InputOutputType {
    Input = 'Input',
    Output = 'Output',
}
